import { Button,Col,Card,Input,Label,FormGroup,Form, Dropdown, DropdownToggle,DropdownItem,DropdownMenu} from "reactstrap";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import {useForm} from "react-hook-form";
import { useState,useEffect } from "react";
import ApiService from "../../../services/apiService";
import {toast} from "react-toastify";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { addSchemeTitle, schemeTitle } from "../../../constants";
import Add from "../../table/Add"; 
const AddSchemVillage = () => {
  const navigate = useNavigate();
  const {register,handleSubmit,formState:{errors}} = useForm();
  const [distributaryZone,setDistributaryZone] = useState([]);
 
  const [dropdownOpen,setDropdownOpen] = useState(false);
  useEffect(() => {
    const fetchDistributaryZone = async () => {
    try{
        const response = await ApiService.axiosApi("/dzone",{
            method: "GET",
            params:{
              pageNumber :0,
              pageSize:0
         }
      })
      if(response.success){
        setDistributaryZone(response.data.data);
      }else{
        toast.error(response.message);
      }
    }catch(error){
        console.log(error);
    }
}
    fetchDistributaryZone();
  }, []);

  const onSubmit = async (data :any) => {
    try{
        
        const response = await ApiService.axiosApi("/schemevillage",{
            method: "POST",
            data: data,
        })
        if(response.success){
            console.log(response.data);
            toast.success(response.message);
            navigate("/scheme-village-list");
        }else{
            toast.error(response.message);
        }
    }catch(error){
        console.log(error);
    }
  }

 
  const toggleDropdown = () => setDropdownOpen(prev => !prev);
    return (
             <>
              <Add
               title = {addSchemeTitle}
               parentTitle = {schemeTitle}
               onSubmit = {onSubmit}

               fields = {[
                   {
                    name : "Scheme_Village",
                    label  :"Scheme Village",
                    type: "text",
                    validation :  { required: "Scheme Village is required" }
                   },
                   {
                    name: "Distributary_Zone",
                    label: "Distributary Zone", 
                    isDropdown:true,
                    dropdownData:distributaryZone,
                    dropdownLabel:"distributary_Zone",
                    idFieldName:"DistributaryZoneId"
                   }
                   
               ]}
              />
      
            </>
    )
}   
export default AddSchemVillage;
